export default __webpack_public_path__ + "static/Loomis2_MI-0145.png";